import React, { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App';
import { LEVEL, SENTRY_DSN } from './envs';

import './tailwind.css';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: LEVEL,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
